import React, { useState, useEffect } from 'react';
import ImageViewerModal from '../Modal/ImageViewerModal';

const FallbackImage = ({ 
  src, 
  alt, 
  className = '', 
  fallbackSrc = '/img/avatarnew.png', 
  clickable = true,
  images = null, // Array of images for viewer (if null, will use single image)
  ...props 
}) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (imgSrc !== fallbackSrc) {
      setImgSrc(fallbackSrc);
    }
  };

  const handleClick = () => {
    if (!clickable || !src || src === fallbackSrc) return;
    
    // Determine images array - use provided images array or single image
    const imagesArray = images || [src];
    const index = imagesArray.findIndex(img => 
      typeof img === 'string' ? img === src : img?.src === src
    );
    
    setCurrentImageIndex(index >= 0 ? index : 0);
    setIsViewerOpen(true);
  };

  const shouldBeClickable = clickable && src && src !== fallbackSrc;
  const cursorStyle = shouldBeClickable ? 'cursor-pointer hover:opacity-90 transition-opacity' : '';

  return (
    <>
      <img
        src={imgSrc}
        alt={alt}
        className={`${className} ${cursorStyle}`}
        onError={handleError}
        onClick={handleClick}
        {...props}
      />
      {shouldBeClickable && (images || src) && (
        <ImageViewerModal
          isOpen={isViewerOpen}
          onClose={() => setIsViewerOpen(false)}
          images={images || [src]}
          currentIndex={currentImageIndex}
          setCurrentIndex={setCurrentImageIndex}
        />
      )}
    </>
  );
};

export default FallbackImage;
